import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import logo from '../assets/logo.png';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const menuItems = [
    { label: 'Início', id: 'hero' },
    { label: 'Benefícios', id: 'benefits' },
    { label: 'Como Funciona', id: 'how-it-works' },
    { label: 'Portfólio', id: 'portfolio' },
    { label: 'Depoimentos', id: 'testimonials' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contato', id: 'contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
        }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src={logo}
              alt="3M Solar"
              className="h-12 w-auto object-contain"
            />
            <div className="md:hidden xl:block">
              <span className="block text-xl font-bold text-gray-800 leading-tight">
                3M Solar
              </span>
              <p className="text-xs text-gray-600">Energia Solar</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-orange-600 font-medium transition-colors duration-200 relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-600 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            {/* LINK DO WHATSAPP - Edite o link abaixo */}
            <Button
              onClick={() => window.open('https://wa.me/5538997523325?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20um%20especialista.', '_blank')}
              className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Falar no WhatsApp
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-gray-700 hover:text-orange-600 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t shadow-lg transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
          }`}
      >
        <nav className="container mx-auto px-4 py-4 flex flex-col space-y-3">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="text-left text-gray-700 hover:text-orange-600 font-medium py-2 transition-colors"
            >
              {item.label}
            </button>
          ))}
          {/* LINK DO WHATSAPP - Edite o link abaixo */}
          <Button
            onClick={() => window.open('https://wa.me/5538997523325?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20um%20especialista.', '_blank')}
            className="bg-orange-600 hover:bg-orange-700 text-white w-full mt-2"
          >
            Falar no WhatsApp
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
